import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class LeafWetnessAttribute extends Sensor {
  public leafWetnessChart: any;
  private leafWetnessSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.leafWetnessChart = null;
    this.leafWetnessSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.leafWetnessSensor, position);
      this.leafWetnessSensor[position].push([timestamp, element.leafWetness]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredLeafWetness = this.leafWetnessSensor.filter(series => series.length > 0);

    const positionNodeLeafWetness = this.leafWetnessSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.leafWetnessChart = this.getConfigChar(
      'leafWetness',
      this.getChartSeriesNewNode('Sensor', filteredLeafWetness, positionNodeLeafWetness),
      this.getRanges('leafWetness'),
      this.getLimits('leafWetness')
    );
  }

  public hasLeafWetnessSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.leafWetnessSensor.length &&
      this.leafWetnessSensor[index].length > 0
    );
  }

  public getLeafWetnessSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.leafWetnessSensor.length) {
      const sensorData = this.leafWetnessSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Humectación de la hoja', value: 'leafWetness' }
    ];
  }
}
